module.exports = __webpack_public_path__ + "static/img/009.0fb9cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/009.png
// module id = 5xah
// module chunks = 0